































































import { transferQueryFilter } from '@/store/interfaces/transfer';
import FlatPicker from '@/components/FlatPickr/FlatPicker.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'TransferFilter',
  components: { FlatPicker, },
  props: {
    query: {
      type: String,
      required: true,
    },
  },
  computed: {
    syncedQuery: {
      get(): string {
        return this.query;
      },
      set(value: string): void {
        this.$emit('update:query', value);
      },
    },
  },
  data: () => ({
    filters: {
      recipient_handle_eq: '',
      created_eq: '',
      authorization_number_eq: '',
      user_email_eq: '',
      payment_method_eq: '',
    } as transferQueryFilter,
    paymentMethods: [
      {
        name: 'Tarjeta',
        id: 'credit_card',
      },
      {
        name: 'Balance',
        id: 'cash',
      },
      {
        name: 'Tarjeta y balance',
        id: 'both',
      }
    ],
  }),
  methods: {
    search(): void {
      let filter = '';
      Object.entries(this.filters).forEach(([key, value]) => {
        value && (filter += `&${key}=${value}`);
      });
      this.syncedQuery = filter;
    },
    clear(): void {
      this.filters.recipient_handle_eq = '';
      this.filters.created_eq = '';
      this.filters.authorization_number_eq = '';
      this.filters.user_email_eq = '';
      this.filters.payment_method_eq = '';

      this.syncedQuery = '';
    },
  },
});
